import script from "./BackButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackButton.vue?vue&type=script&lang=ts&setup=true"

import "./BackButton.vue?vue&type=style&index=0&id=00390909&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00390909"]])

export default __exports__